// FIXME: Use Constants in Redux instead and remove when the mobile is ready
export default {
  ACADEMIC_YEARS_MODULE_NAME: '@module/academic-years',
  ANNOUNCEMENTS_MODULE_NAME: '@module/announcements',
  AUTH_MODULE_NAME: '@module/authentication',
  CLASSES_MODULE_NAME: '@module/classes',
  COURSE_GRADEBOOK_POLICIES_MODULE_NAME: '@module/course-gradebook-policies',
  COURSES_MODULE_NAME: '@module/courses',
  COURSE_TEMPLATES_MODULE_NAME: '@module/course-templates',
  GRADEBOOK_SYSTEMS_MODULE_NAME: '@module/gradebook-systems',
  GRADE_CATEGORIES_MODULE_NAME: '@module/grade-categories',
  MESSAGES_MODULE_NAME: '@module/messages',
  NOTIFICATIONS_MODULE_NAME: '@module/notifications',
  ORGANIZATIONS_MODULE_NAME: '@module/organizations',
  ROLES_MODULE_NAME: '@module/roles',
  SCHOOLS_MODULE_NAME: '@module/schools',
  SEMESTERS_MODULE_NAME: '@module/semesters',
  STAGE_GRADEBOOK_DISPLAY_MODULE_NAME: '@module/stage-gradebook-display',
  STAGES_MODULE_NAME: '@module/stages',
  SUBJECTS_MODULE_NAME: '@module/subjects',
  USERS_MODULE_NAME: '@module/users',
  MATERIALS_MODULE_NAME: '@module/materials',
  GRADABLE_ITEM_MODULE_NAME: '@module/gradable-item',
  CALENDARS_MODULE_NAME: '@module/calendars',
  CLASS_SCHEDULES_MODULE_NAME: '@module/class-schedules'
};